export const getSystemLocale = () => {
  const params = new URLSearchParams(window.location.search);
  const uiTestLocale = params.get('uiTestLocale');
  if (uiTestLocale) {
    return uiTestLocale;
  }
  return navigator.language.split(/[-_]/)[0] ?? 'en'; // language without region code
};
